<template>
  <div class="idCardUpload">
    <div class="title" v-show="!show">
      <span class="tip"
        >温馨提示：请保持图片清晰，建议在光照充足的环境下拍摄</span
      >
    </div>
    <div class="uploadBtn" v-show="!show">
      <!--正面-->
      <div
        class="uploadItem"
        @click="handleFrontClick"
        :class="{ frontImgBg: frontImg }"
      >
        <img
          v-if="!frontImg"
          class="Photograph"
          src="@/assets/style/Photograph-icon.png"
          alt=""
        />
        <img
          v-if="frontImg"
          class="delect"
          src="@/assets/style/delect-icon.png"
          alt=""
          @click.stop="clearFront"
        />
        <img
          class="idCard"
          v-if="!frontImg"
          src="@/assets/style/id-card-icon.png"
          alt=""
        />
        <img class="idCard" v-else :src="frontImg" alt="" />
        <input
          type="file"
          ref="frontInput"
          hidden
          @change="onFrontChange"
          accept="image/*"
        />
      </div>
      <div class="id-tip">
        <div class="tip">点击上传身份证原件人像面</div>
      </div>
      <!--背面-->
      <div
        class="uploadItem"
        @click="handleBackClick"
        :class="{ backImgBg: backImg }"
      >
        <img
          v-if="!backImg"
          class="Photograph"
          src="@/assets/style/Photograph-icon.png"
          alt=""
        />
        <img
          v-if="backImg"
          class="delect"
          src="@/assets/style/delect-icon.png"
          alt=""
          @click.stop="clearBack"
        />
        <img
          class="idCard"
          v-if="!backImg"
          src="@/assets/style/ofid-card-icon.png"
          alt=""
        />
        <img class="idCard" v-else :src="backImg" alt="" />
        <input
          type="file"
          ref="backInput"
          hidden
          @change="onBackChange"
          accept="image/*"
        />
      </div>
      <div class="id-tip">
        <div class="tip">点击上传身份证原件国徽面</div>
      </div>
    </div>
    <!--提交按钮-->
    <div v-show="!show" class="submitBtn" @click="handleDialogShow">
      <div :class="{ disabled: disabled }" class="submitText">提交资料</div>
    </div>
    <!--二次确认信息弹框-->
    <confirmPopup ref="confirmPopupRef" @submitClick="handleSubmitClick" />
    <div class="block"></div>
  </div>
</template>
<script>
import confirmPopup from "@/components/idCardBinding/confirmPopup.vue";
import {
  uploadImg,
  verificationIdCardOCR,
  addIdCard,
  verificationIdCardOCRWeb,
  preCheck,
  verificationIdCardOCRWebCallback,
} from "@/api/index";
import { ImagePreview } from "vant";
import { setLocalStorageData,getLocalStorageData } from "@/common/index.js";

export default {
  name: "IdCardUpload",
  props: {},
  components: {
    confirmPopup,
  },
  data() {
    return {
      frontImg: "",
      backImg: "",
      frontImgRaw: "",
      backImgRaw: "",
      frontKey: "",
      backKey: "",
      show: false,
      userInfo: {},
      avatar: "",
      timer: null,
      frontBase64: "",
      backBase64: "",
      retryCount: 0,
    };
  },
  activated() {},
  deactivated() {
    clearInterval(this.timer);
  },
  methods: {
    async init() {
      this.$refs.confirmPopupRef
        ? (this.$refs.confirmPopupRef.show = false)
        : null;
      this.show = false;
      const userAllInfo = getLocalStorageData("UserAllInfo") || {};
      if (userAllInfo.authentication?.idCardFront) {
        this.frontImg = userAllInfo.authentication.idCardFront;
        this.frontImgRaw = userAllInfo.authentication.idCardFront;
        this.frontKey = userAllInfo.authentication.idCardFront;
        this.frontBase64 = userAllInfo.authentication.idCardFront;

        this.backImg = userAllInfo.authentication.idCardBackend;
        this.backImgRaw = userAllInfo.authentication.idCardBackend;
        this.backKey = userAllInfo.authentication.idCardBackend;
        this.backBase64 = userAllInfo.authentication.idCardBackend;
        await this.getCardOCR(this.frontBase64,2);
        await this.getBackCardOCR(this.backBase64,2);
      } else {
        this.frontImg = "";
        this.backImg = "";
        this.frontImgRaw = "";
        this.backImgRaw = "";
        this.frontKey = "";
        this.backKey = "";
        this.frontBase64 = "";
        this.backBase64 = "";
        this.$nextTick(() => {
          if (this.$refs.frontInput) this.$refs.frontInput.value = "";
          if (this.$refs.backInput) this.$refs.backInput.value = "";
        });
      }
    },
    clearFront() {
      if (this.$refs.frontInput) this.$refs.frontInput.value = "";
      this.frontImg = "";
      this.frontImgRaw = "";
      this.frontKey = "";
      this.frontBase64 = "";
    },
    clearBack() {
      if (this.$refs.backInput) this.$refs.backInput.value = "";
      this.backImg = "";
      this.backImgRaw = "";
      this.backKey = "";
      this.backBase64 = "";
    },
    //去掉img前缀
    removeImgPrefix(url) {
      return url.replace(/^data:image\/(png|jpeg|jpg|webp);base64,/, "");
    },
    readFileAsDataUrl(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target?.result || "");
        reader.onerror = () => resolve("");
        reader.readAsDataURL(file);
      });
    },
    openPreview(src) {
      if (!src) return;
      ImagePreview([src]);
    },
    handleFrontClick() {
      if (this.frontImg) {
        this.openPreview(this.frontImgRaw || this.frontImg);
        return;
      }
      this.handleFrontUpload();
    },
    handleBackClick() {
      if (this.backImg) {
        this.openPreview(this.backImgRaw || this.backImg);
        return;
      }
      this.handleBackUpload();
    },
    async resizeImage(file) {
      if (!file) return { blob: null, dataUrl: "" };
      const mime = /^image\/(png|jpeg|jpg|webp)$/i.test(file.type)
        ? file.type
        : "image/jpeg";
      const maxWidth = 1000;
      const bitmapUrl = URL.createObjectURL(file);
      try {
        const img = await new Promise((resolve, reject) => {
          const image = new Image();
          image.onload = () => resolve(image);
          image.onerror = reject;
          image.src = bitmapUrl;
        });

        const srcW = img.naturalWidth || img.width;
        const srcH = img.naturalHeight || img.height;
        if (!srcW || !srcH) return { blob: null, dataUrl: "" };

        const scale = srcW > maxWidth ? maxWidth / srcW : 1;
        const outW = Math.round(srcW * scale);
        const outH = Math.round(srcH * scale);

        const canvas = document.createElement("canvas");
        canvas.width = outW;
        canvas.height = outH;
        const ctx = canvas.getContext("2d");
        if (!ctx) return { blob: null, dataUrl: "" };
        ctx.drawImage(img, 0, 0, outW, outH);

        const dataUrl = canvas.toDataURL(
          mime,
          mime === "image/jpeg" ? 0.7 : undefined,
        );
        const blob = await new Promise((resolve) => {
          canvas.toBlob(
            (b) => resolve(b),
            mime,
            mime === "image/jpeg" ? 0.7 : undefined,
          );
        });
        return { blob, dataUrl };
      } finally {
        URL.revokeObjectURL(bitmapUrl);
      }
    },
    handleFrontUpload() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("picType", { type: "1" });
        this.$JSBridge.listen("pushPic", async (res) => {
          console.log(res, "pushPic事件11111");
          if (res.type == "1") {
            this.frontImg = res.data.url;
            this.frontImgRaw = res.data.url;
            this.frontKey = res.data.key;
            this.frontBase64 = res.data.base64Img;
            await this.getCardOCR(this.frontBase64);
          }
        });
      } else {
        this.$refs.frontInput.click();
      }
    },
    handleBackUpload() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("picType", { type: "2" });
        this.$JSBridge.listen("pushPic", async (res) => {
          console.log(res, "pushPic事件22222");
          if (res.type == "2") {
            this.backImg = res.data.url;
            this.backImgRaw = res.data.url;
            this.backKey = res.data.key;
            this.backBase64 = res.data.base64Img;
            await this.getBackCardOCR(this.backBase64);
          }
        });
      } else {
        this.$refs.backInput.click();
      }
    },
    async onFrontChange(e) {
      const inputEl = e?.target;
      const file = inputEl?.files?.[0];
      if (!file) return;
      this.$store.commit("setLoading", true);
      try {
        this.frontImgRaw = await this.readFileAsDataUrl(file);
        const { blob, dataUrl } = await this.resizeImage(file);
        if (dataUrl) {
          this.frontImg = dataUrl;
        } else {
          this.uploadFile(file, "frontImg");
        }
        if (process.env.VUE_APP_ENV != "productionApp") {
          this.frontBase64 = this.removeImgPrefix(this.frontImg);
        }
        const uploadFile = blob
          ? new File([blob], file.name, { type: blob.type || file.type })
          : file;
        const formData = new FormData();
        formData.append("file", uploadFile);
        const res = await uploadImg(formData);
        if (res.code !== 2000) {
          this.$toast(res.msg || res.message || "请求失败");
          return;
        }
        this.frontKey = res.data.key;
      } finally {
        this.$store.commit("setLoading", false);
        await this.getCardOCR(this.frontBase64);
        if (inputEl) inputEl.value = "";
      }
    },
    async onBackChange(e) {
      const inputEl = e?.target;
      const file = inputEl?.files?.[0];
      if (!file) return;
      this.$store.commit("setLoading", true);
      try {
        this.backImgRaw = await this.readFileAsDataUrl(file);
        const { blob, dataUrl } = await this.resizeImage(file);
        if (dataUrl) {
          this.backImg = dataUrl;
        } else {
          this.uploadFile(file, "backImg");
        }
        if (process.env.VUE_APP_ENV != "productionApp") {
          this.backBase64 = this.removeImgPrefix(
            String(this.backImg || "").startsWith("data:image/")
              ? this.backImg
              : this.backImgRaw,
          );
        }
        const uploadFile = blob
          ? new File([blob], file.name, { type: blob.type || file.type })
          : file;
        const formData = new FormData();
        formData.append("file", uploadFile);
        const res = await uploadImg(formData);
        if (res.code !== 2000) {
          this.$toast(res.msg || res.message || "请求失败");
          return;
        }
        this.backKey = res.data.key;
      } finally {
        this.$store.commit("setLoading", false);
        await this.getBackCardOCR(this.backBase64);
        if (inputEl) inputEl.value = "";
      }
    },
    uploadFile(file, type) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        this[type] = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    // 提交绑定身份证
    async handleSubmitClick(userInfo) {
      const params = {
        frontPictureKey: this.frontKey,
        backPictureKey: this.backKey,
        ocrName: userInfo.ocrName,
        ocrCardNo: userInfo.ocrCardNo,
        expireDate: userInfo.expireDate,
        gender: userInfo.gender,
        address: userInfo.address,
      };
      const res = await addIdCard(params);
      if (res.code !== 2000) {
        this.$toast(res.msg || res.message || "请求失败");
        return;
      }
      const ocrParams = {
        ocrName: userInfo.ocrName,
        ocrCardNo: userInfo.ocrCardNo,
        redirectUrl: "",
      };
      if (process.env.VUE_APP_ENV !== "productionApp") {
        ocrParams.redirectUrl = `${window.location.origin}${window.location.pathname}#/idCardLoading`;
      }
      const ocrRes = await verificationIdCardOCRWeb(ocrParams);
      if (ocrRes.code !== 2000) {
        this.$toast(ocrRes.msg || ocrRes.message || "请求失败");
        return;
      } else {
        if (process.env.VUE_APP_ENV === "productionApp") {
          this.$JSBridge.send("serviceType", {
            type: "2",
            ocrAutoUrl: ocrRes.data.identifyUrl,
          });
          this.$JSBridge.listen("pushLiveBack", async (res) => {
            console.log(res, "pushLiveBack");
            if (res.data.result == "1" || res.data.result == "2") {
              let OCRWebCallback = await verificationIdCardOCRWebCallback();
              if (
                OCRWebCallback.code == 2000 &&
                OCRWebCallback.data.authState == 3
              ) {
                const preCheckRes = await preCheck({});
                this.$store.commit("setPreCheckData", preCheckRes);
                setLocalStorageData("preCheckData", preCheckRes);
                this.$emit("submitClick");
                return;
              }
            }
          });
        } else {
          window.location.href = ocrRes.data.identifyUrl;
        }
      }
    },
    async handleDialogShow() {
      if (this.disabled) {
        return;
      }
      this.retryCount++;
      this.$store.commit("setLoading", true); // 发送请求前，设置loading状态为true
      if (
        this.userInfo.ocrName &&
        this.userInfo.ocrCardNo &&
        this.userInfo.expireDate
      ) {
        this.$store.commit("setLoading", false); // 发送请求后，设置loading状态为false
        this.$refs.confirmPopupRef.userInfo = this.userInfo;
        this.$store.commit("setRealNameProtocol", this.userInfo);
        this.$refs.confirmPopupRef.isChecked = false;
        this.$refs.confirmPopupRef.init();
        this.retryCount = 0;
      } else {
        // 限制最多重试 5 次（5秒），超过时间报错，防止无限死循环
        if (this.retryCount >= 10) {
          this.retryCount = 0; // 重置计数
          this.$store.commit("setLoading", false); // 关闭 Loading
          this.$toast("响应超时，请稍后重试");
          return;
        } else {
          setTimeout(() => {
            this.handleDialogShow();
          }, 1000);
        }
      }
    },
    // 身份证正面OCR识别
    async getCardOCR(frontBase64,type = 1) {
      const params = {
        side: "front",
      }
      type == 1 ? params.base64Img = frontBase64 : params.urlImg = frontBase64;
      let res = await verificationIdCardOCR(params);
      if (res.code !== 2000) {
        this.retryCount = 0; // 重置计数
        this.$store.commit("setLoading", false); // 关闭 Loading
        this.$toast(res.msg || res.message || "提交失败");
        return;
      }
      this.userInfo.ocrName = res?.data?.ocrName || "";
      this.userInfo.ocrCardNo = res?.data?.ocrCardNo || "";
      if (res.data.gender) {
        this.userInfo.gender =
          res.data.gender == "男" ? 1 : res.data.gender == "女" ? 2 : 3;
      }
      this.userInfo.address = res?.data?.address || "";
      this.$store.commit("setRealNameProtocol", this.userInfo);
    },
    // 身份证反面OCR识别
    async getBackCardOCR(backBase64,type = 1) {
      const params = {
        side: "back",
      }
      type == 1 ? params.base64Img = backBase64 : params.urlImg = backBase64;
      let res = await verificationIdCardOCR(params);
      if (res.code !== 2000) {
        this.retryCount = 0; // 重置计数
        this.$store.commit("setLoading", false); // 关闭 Loading
        this.$toast(res.msg || res.message || "提交失败");
        return;
      }
      this.userInfo.expireDate = res?.data?.expireDate || "";
    },
  },
  computed: {
    disabled() {
      return !this.frontImg || !this.backImg;
    },
  },
};
</script>
<style scoped lang="scss">
.idCardUpload {
}
.title {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  .tip {
    font-size: 12px;
    color: #f9ae3d;
  }
}
.uploadBtn {
  display: flex;
  flex-direction: column;
}
.uploadItem {
  cursor: pointer;
  position: relative;
  .Photograph {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 30%;
    transform: translateY(-30%);
    left: 50%;
    transform: translateX(-50%);
  }
  .delect {
    width: 17px;
    height: 17px;
    position: absolute;
    top: 14px;
    right: 14px;
  }
  .idCard {
    width: 100%;
    border-radius: 12px;
    height: 230px;
    object-fit: contain;
  }
}
.frontImgBg {
  background: #e9967d;
  border-radius: 16px;
}
.backImgBg {
  background: #e9967d;
  border-radius: 16px;
}
.submitBtn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 94px;
  line-height: 94px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px -2px 19px 0px rgba(0, 0, 0, 0.15),
    0px 1px 7px 0px rgba(0, 0, 0, 0.15);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  .submitText {
    background: #F24334;
    border-radius: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #fff;
    height: 51px;
    margin: 0px 16px;
    width: 100%;
  }
  .disabled {
    background: #FFC2BD;
  }
}
.id-tip {
  font-size: 11px;
  color: #D4A038;
  text-align: center;
  position: relative;
  margin-top: 8px;
  margin-bottom: 26px;
}
.block {
  height: 120px;
  width: 100%;
  background: transparent;
}
</style>
